import {utilsTypeof} from "../../../shared/utils/utilsTypeof";

export const excludeFieldsFromResponse =
    <T extends Record<string, any>>(data: T, excludeFields: string[]): T => {
        if (!utilsTypeof.isObject(data)) {
            console.info('Should be of type Object');
            return data
        }
        const clean = Object.keys(data).reduce((acc, key) => {
            if (excludeFields.includes(key)) {
                return acc;
            }
            return {...acc, [key]: data[key]};
        }, {}) as T
        return clean
    }